module.exports = __webpack_public_path__ + "img/60.2d64259d.png";